import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "availability",
  "use": "availability-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"availability\"><path fill-rule=\"evenodd\" d=\"M11.29 0v4H16v4.47h-4.7v-.94h-.94v.94H5.65v-.94h-.94v.94H0V4h4.71V0zM5.65.94V4h4.71V.94zm4.7 9.41h.94v-.94H16V16H0V9.41h4.71v.94h.94v-.94h4.7z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol